import React, {Component} from 'react'
import './styles.css'
import {Formik, Field, Form, isInteger} from 'formik'
import {api, apiLocal} from '../../services/api'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import Util from '../../classes/util'
import axios from 'axios'
import {server, showError} from '../../common'
import InputMask from 'react-input-mask'
import {Redirect} from 'react-router-dom'
import Image from 'react-bootstrap/Image'
import {PRECISA_LOGAR, CAMINHO_FOTOS} from '../../config'
import {connect} from 'react-redux'
import moment from 'moment'


import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const estadoInicial = {
    employees: [],
    ships: [],
    feed: [],
    employee: 0,
    ship: 0,
    ship_name: '',
    day: parseInt(Util.completarZerosEsquerda(moment().format('D'), 2)),
    month:Util.completarZerosEsquerda(moment().format('MM'), 2),
    year: moment().format('yyyy'),
    time: moment().format('HH:mm'),
    text: '',
    texto: '',
    notificacao: 0,
    id: null,
    files: [],
    qtdFiles: 1,
    fotosEnviar: [],
    fotosCarregadas: [],
    thumbsEnviar: [],
    thumbsCarregadas: [],
    redirect: false,
    finalizaOperacao: false,
    loading: true
}

class AddFeed extends Component {

    state = {
        ...estadoInicial,
    }

    async componentDidMount() {
        window.scrollTo(0, 0)
        var id = this.props.match.params.id
        await this.setState({token: this.props.token, id, ship: this.props.location.state.ship, ship_name: this.props.location.state.ship_name})
        // console.log('Ship name: ' + this.state.ship_name + 'e ship: ' + this.state.ship)
        if(id != 0){
            await this.setState({feed: this.props.location.state.feed})
            await this.loadData(this.props.location.state.feed)
            await this.carregaPictures()  
        } 
        //console.log(`id ship: ${this.state.ship}`)           
        await this.carregaEmployees()
        await this.carregaShips()

    }

    loadData = async(feed) => {
        await this.setState({day: feed.day, month: feed.month, year: feed.year, time: feed.time, text: feed.text, employee: feed.id_employee, ship: feed.id_ship, texto: feed.description})
       }

    carregaEmployees = async () => {
        try{          
            await apiEmployee.post(`getEmployees.php`, {
                token: this.state.token
            }).then(
                async res => {
                     if(res.data == 'false'){
                         alert('Usuário não logado!')
                     }else{
                         await this.setState({employees: res.data})                        
                     }
                 },
                async res => alert(res.data) 
            )
        }catch(e){
            alert(e)
        }
    }

    carregaPictures = async () => {
        await apiEmployee.post('getPictures.php', {
            token: this.state.token,
            id_feed: this.state.id
        }).then(
            async res => {
                await this.setState({fotosCarregadas: res.data})
                if(this.state.fotosCarregadas.length > 0){
                    this.state.fotosCarregadas.map(async foto => {
                       await this.setState({thumbsCarregadas: [...this.state.thumbsCarregadas, `${CAMINHO_FOTOS}${foto.link}.png`]})
                    })
                }
            },
            res => alert(`Erro`)
        )
    }

    carregaShips = async () => {
        await apiEmployee.post(`getShips.php`, {
            token: this.state.token
        }).then(
            response => {this.setState({ships: response.data})},
            response => this.erroApi(response)
        ) 
    }

    erroApi = async (res) => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    addFoto = async (event) => {
        //console.log(event.target.files[0])
        await this.setState({thumbsEnviar: [...this.state.thumbsEnviar, URL.createObjectURL(event.target.files[0])], fotosEnviar: [...this.state.fotosEnviar, event.target.files[0]]})
        await this.inserirFotos()
    }

    apagarFoto = async (foto) => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                  <h1>Rio Grande Fumigação</h1>
                  <p>Deseja apagar esta foto?</p>
                  <button style={{marginRight: 5}}className="btn btn-success w-25"
                    onClick={async () => {
                        onClose()
                    }}
                    >
                    Não
                  </button>
                  <button style={{marginRight: 5, marginLeft: 5}}className="btn btn-danger w-25"
                    onClick={async () => {
                        //console.log(foto.link)
                        await apiEmployee.post('deletePicture.php', {
                            token: this.props.token,
                            id_picture: foto.id,
                            link: foto.link
                        }).then(
                            async res => {
                                await alert(`Foto removida!`)
                                window.location.reload()
                            },
                            async res => {}//await console.log(res.data)
                        )
                        onClose()
                        //console.log(JSON.stringify(foto))
                    }}
                    >
                    Sim
                  </button>
                </div>
              )
            }
          })
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    });
    
    inserirFeed = async () => {
            alert('aqui')
            let values = `'${this.state.day}', '${this.state.month}', '${this.state.year}', ` + 
            `'${this.state.time}', '${this.state.text}', '${this.state.ship}', '${this.state.texto}'`
            // console.log(values)
            await apiEmployee.post(`insertFeed.php`, {
                token: this.props.token,
                values: values
            }).then(
                 async res => {
                    if(res.data == true){
                        if(parseInt(this.state.notificacao) === 1){
                            await apiEmployee.post(`notificacao_feed.php`, {
                                token: this.props.token,
                                navio: this.state.ship_name,
                                feed: this.state.text,
                                id_ship: this.state.ship  
                            }).then(
                                async res => {
                                    alert('Notificação enviada!')
                                },
                                async res => alert('erro')
                            )
                        }else{
                            // console.log('Não enviar notificação')
                        }
                        await this.setState({finalizaOperacao: true})
                    } 
                },
                 async res => await alert(`erro: ${res.data}`)
            )
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

    inserirFotos = async () => {

        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                  <h1>Rio Grande Fumigação</h1>
                  <p>Deseja inserir esta foto?</p>
                  <button style={{marginRight: 5}}className="btn btn-danger w-25"
                    onClick={async () => {
                        await this.setState({thumbsEnviar: [], fotosEnviar: []})
                        onClose()
                    }}
                    >
                    Não
                  </button>
                  <button style={{marginRight: 5, marginLeft: 5}}className="btn btn-success w-25"
                    onClick = {async () => {
                     this.state.fotosEnviar.map(async foto => {
                        //console.log(foto)
                        let result = await this.toBase64(foto)
                        //console.log(result)
                        
                        await apiEmployee.post(`insertPicture.php`, {
                            token: this.props.token,
                            id_feed: this.state.id,
                            picture: result
                        }).then(
                            async res => {
                                //console.log(res.data)
                                this.sleep(2000)
                                alert('Foto salva!')
                                await onClose()
                                await this.setState({finalizaOperacao: true})
                            },
                            res => {}//console.log(res.data)
                        )
                    })
                    }}
                    >
                    Sim
                  </button>
                </div>
              )
            }
          })   
    }              

    limpaControles = async () => {
        await this.setState({employee: null, ship: null, day: null, month: null, year: null, text: '', time: ''})
    }

    radioAzul = () => {
        return (
            <Radio color='primary' />
        )
    }

    render(){
        const validations = []
        validations.push(this.state.ship && this.state.ship > 0)
        validations.push(this.state.employee && this.state.employee > 0)
        validations.push(this.state.day && Math.ceil(this.state.day) <= 31)
        validations.push(this.state.month && Math.ceil(this.state.month) <= 12)
        validations.push(this.state.year && Math.ceil(this.state.year) <= 9999)
        validations.push(this.state.text && this.state.text.trim().length >= 8)
        validations.push(this.state.time && this.state.time.trim().length >= 5)

        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)
        
        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {this.state.finalizaOperacao &&
                    <Redirect to={'/admin/ships'} />
                }
                
                <section className="page-add">
                    <Header voltarShips />
                    
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12-col-sm-12 col-12">
                                <div className="page-breadcrumb">
                                    <h2 style={{marginBottom: '3%', marginTop: '3%', textAlign: 'center'}}>{this.state.id == 0 ? 'Inserir novo feed' : 'Alterar feed'}</h2>
                                </div>
                            </div>
                        </div>

                </section>

                <div className="contact-section">
                    
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-xl-8 col-lg-8 col-md-8-col-sm-8 col-8">
                                <Formik 
                                initialValues={{
                                    ship: null,
                                    employee: null,
                                    day: null,
                                    month: null,
                                    year: null,
                                    time: null,
                                    text: '',
                                    texto: ''
                                }}
                                onSubmit={async values => {
                                    await new Promise(r => setTimeout(r, 2000))
                                    this.inserirFeed()
                                }}
                                >
                                    <Form className="contact-form">

                                    <div className="row">
                                        <div className="col-3 col-xl col-lg-1 col-md-1 col-sm-3 text-left">
                                            <label htmlFor="seaport_origin">Employee</label>
                                        </div>
                                        <div className="col-9 col-xl-5 col-lg-5 col-md-5 col-sm-9 text-left">
                                            <Field as="select" name="employee" id="employee" value={this.state.employee} onChange={async e => { await this.setState({employee: e.currentTarget.value})}}>
                                                {this.state.employees.map(seaport => (
                                                    <option key={seaport.id} value={seaport.id}>{seaport.name}</option>
                                                ))}
                                            </Field>
                                        </div>
                                    </div>

                                    <div className="row">

                                        <div className="col-3 col-xl-1 col-lg-1 col-md-2 col-sm-3 text-left">
                                            <label htmlFor="day">Day: </label>
                                        </div>
                                        <div className="col-9 col-xl-2 col-lg-2 col-md-4 col-sm-9">
                                            <Field min={1} max={31} value={this.state.day} onChange={e => { this.setState({day: e.currentTarget.value})}} id="day" name="day" type="number"/>
                                        </div>
                                        <div className="col-3 col-xl-1 col-lg-1 col-md-2 col-sm-3 text-left">
                                            <label htmlFor="month">Month: </label>
                                        </div>
                                        <div className="col-9 col-xl-2 col-lg-2 col-md-4 col-sm-9">
                                            <Field value={this.state.month} onChange={e => { this.setState({month: e.currentTarget.value})}} id="month" name="month" type="number"  min={1} max={12}  />
                                        </div>
                                        <div className="col-3 col-xl-1 col-lg-1 col-md-2 col-sm-3 text-left">
                                            <label htmlFor="year">Year: </label>
                                        </div>
                                        <div className="col-9 col-xl-2 col-lg-2 col-md-4 col-sm-9">
                                            <Field value={this.state.year} onChange={e => { this.setState({year: e.currentTarget.value})}} id="year" name="year" type="number" />
                                        </div>
                                        <div className="col-3 col-xl-1 col-lg-1 col-md-2 col-sm-3 text-left">
                                            <label htmlFor="time">time: </label>
                                        </div>
                                        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-9 col-9">
                                            <InputMask mask="99:99" value={this.state.time} onChange={e => { this.setState({time: e.currentTarget.value})}} id="time" name="time" type="text" />
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-2">
                                            <Field as="select" className="form-control" as="select" name="selectText" id="selectText" value={this.state.selectText} onChange={async e => { await this.setState({text: e.currentTarget.value})}}>
                                                <option value={'Ship Berthed'}>Ship berthed</option>
                                                <option value={'Holds inspections'}> Holds inspections</option>
                                                <option value={'Start loading'}>Start loading</option>
                                                <option value={'Fumigation Safety Instruction'}>Fumigation Safety Instruction</option>
                                                <option value={'Fumigation Team on Board'}>Fumigation team on board</option>
                                                <option value={'Start Fumigation Procedure'}>Start Fumigation Procedure</option>
                                                <option value={'Leak Test'}>Leak Test</option>
                                                <option value={'Completed Fumigation Procedure'}>Completed Fumigation Procedure</option>
                                            </Field>
                                        </div>

                                        <div className="col-10">
                                            <input value={this.state.text} name="text" id="text" placeholder="Status" onChange={e => { this.setState({text: e.currentTarget.value})}}/>
                                        </div>
                                        
                                        <div className="col-2">
                                            <label htmlFor="texto">Texto: </label>
                                        </div>
                                        
                                        <div className="col-10">
                                            <input value={this.state.texto} name="texto" id="texto" placeholder="Texto" onChange={e => { this.setState({texto: e.currentTarget.value})}}/>
                                        </div> 

                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12 col-md-12-col-sm-12 text-right">
                                        <label htmlFor="notificacao" className="form-check-label">Enviar Notificação?</label>
                                            <FormControl component="fieldset">
                                                <RadioGroup 
                                                    row 
                                                    aria-label="notificacao" 
                                                    name="notificacao" 
                                                    value={this.state.notificacao} 
                                                    onChange={
                                                        async (event) => {await this.setState({notificacao: event.target.value})}
                                                    }
                                                    
                                        
                                                >
                                                    <FormControlLabel color='primary' checked={parseInt(this.state.notificacao) === 0} value={0} control={this.radioAzul()} label="No" />
                                                    <FormControlLabel color='primary' checked={parseInt(this.state.notificacao) === 1} value={1} control={this.radioAzul()} label="Yes" />
                                                </RadioGroup>
                                            </FormControl>  
                                        </div>
                                    </div>   

                                    <div className="row">
                                        <div className="col-lg-12 col-md-12-col-sm-12 text-right">
                                            <button disabled={!validForm} type="submit" style={validForm ? {backgroundColor: '#eee', opacity: 0.9} : {backgroundColor: '#eee', opacity: 0.3} } >{this.state.id == 0 ? 'Adicionar' : 'Alterar'}</button>
                                        </div>
                                    </div>                         

                                    </Form>
                                </Formik>
                            </div>
                        </div>
                        {this.state.id > 0 &&
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 text-left">
                                <label className="form-control">Fotos: </label>
                            </div>
                            <div className="col-2"></div>

                            {this.state.fotosCarregadas.length > 0 && this.state.fotosCarregadas.map((foto, index) => (
                                <div key={index} className="col-12">
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-3">
                                            <p>Nome: {foto.link}</p>
                                        </div>
                                        <div className="col-4">
                                            <Image src={this.state.thumbsCarregadas[index]} thumbnail fluid style={{maxHeight: 320, maxWidth: 320}}/> 
                                        </div>
                                        <div className="col-1 text-left">
                                            <button className="btn btn-danger" onClick={() => this.apagarFoto(foto)}>Remover foto</button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>
                                </div>
                            ))}
                            <div className="col-2"></div>
                            <div className="col-8">
                                <label htmlFor="fotos">Escolha uma foto</label>
                                <input type="file" name="fotos" id="fotos" multiple accept="image/png" placeholder="inserir fotos" onChange={(event) => this.addFoto(event)} />
                            </div>
                            <div className="col-2"></div>
                            {this.state.fotosEnviar.length > 0 && this.state.fotosEnviar.map((foto, index) => (
                                <div key={index} className="col-12">
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-3">
                                            <p>Nome: {foto.name}</p>
                                        </div>
                                        <div className="col-4">
                                            <Image src={this.state.thumbsEnviar[index]} thumbnail fluid style={{maxHeight: 320, maxWidth: 320}}/> 
                                        </div>
                                        <div className="col-1 text-left">
                                            <button className="btn btn-danger" onClick={() => this.removerFoto(index)}>Remover foto</button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>
                                </div>
                            ))}
                                {this.state.fotosEnviar.length > 0 &&
                                    <button className="btn btn-success" onClick={() => this.inserirFotos()}>{this.state.thumbsCarregadas.length > 1 ? `Enviar fotos` : `Enviar foto`}</button>
                                }
                            </div>
                        }
                </div>
                
            </div>
        )
        
    }
}

const mapStateToProps = ({user}) => {
    return{
        token: user.token
    }
}

export default connect(mapStateToProps, null)(AddFeed)

 /*
    inserirFeed = async () => {
        await api.post(`feed`, {
            employee: this.state.employee,
            ship: this.state.ship,
            year: this.state.year,
            month: this.state.month,
            day: this.state.day,
            time: this.state.time,
            text: this.state.text
        }).then(response => {
            if(response.status === 204){
                alert("Feed inserido corretamente!")
                this.limpaControles()
            }else{
                alert("Erro na inserção! Tente novamente!")
            }
        })
    }

    <div className="col-3 col-xl-1 col-lg-1 col-md-1 col-sm-3 text-left">
                                            <label htmlFor="seaport_destiny">Ship</label>
                                        </div>
                                        <div className="col-9 col-xl-5 col-lg-5 col-md-5 col-sm-9 text-left">
                                            <Field as="select" name="ship" id="ship" value={this.state.ship} onChange={async e => { await this.setState({ship: e.currentTarget.value})}}>
                                                {this.state.ships.map(ship => (
                                                    <option key={ship.id} value={ship.id}>{ship.name}</option>
                                                ))}
                                            </Field>
                                        </div>

*/